import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * При смене маршрута прокручиваем страницу наверх.
 * Без этого SPA «открывает» новые страницы посередине,
 * потому что браузер сохраняет позицию скролла.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
